import React from 'react'
import Header from './Header'
import Footer from './Footer'
import Admin from './Admin'

const About = () => {
  let name = 'iLander'
  let img1 = 'angular.png'
  let arr = ["UI","UX"]
  let obj = {name:"UI",duration:"60Days"}
  let sty = {textAlign:"center",color:"red",margin:"30px"}
  let arr1 = [
    {name:"UI",duration:"60Days"}
  ]
  return (
    <>
      <Header />
      <h1 style={sty}>Welcome to About Component {name}</h1>
      <img src={"assets/images/"+img1} alt="" width={"50%"} height={250} />
      <h2 style={sty}>{"ilander".toUpperCase()}</h2>
      <ul>
        <li>{arr[0]}</li>
        <li>{arr[1]}</li>
        <li>{obj.duration}</li>
        <li>{arr1[0].name}</li>
      </ul>
      <Admin x={name} y={img1} z={obj} />
      <Footer />     
    </>
  )
}

export default About
